import { useMediaQuery } from "@chakra-ui/react";
import Controls from "./Controls";
import MainViewHeader from "./MainView/Header";
import PostsViewHeader from "./PostsView/PostsViewHeader";

const Header = () => {
  const [isMedium] = useMediaQuery(["(min-width: 768px)"]);

  return (
    <div className="flex items-center justify-between">
      <MainViewHeader />
      {!isMedium && <PostsViewHeader />}
      <div className="hidden items-center gap-10 pr-5 md:flex">
        <Controls />
      </div>
    </div>
  );
};

export default Header;
